import {Component, Injector} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {FrontendFormComponent} from '@abstract/frontend.form.component';
import {TechnicalDeviceElementApiService} from '@api/technical-device-element.api.service';
import {Utils} from '@helpers/utils';
import {ConclusionFormDataService} from '../services/conclusion-form-data.service';
import {FormGroup} from '@angular/forms';
import {EventsService} from '@services/events.service';
import {Conclusion} from '@namespaces/conclusion.namespace';
import {RoutesStorage} from '@helpers/routes.helper';
import {ScrollToService} from '@services/scroll-to.service';
import {NotyMessagesEnum} from '@helpers/noty-messages.enum';

@Component({
    selector: 'app-conclusion-form',
    templateUrl: './conclusion-form.component.html',
    styleUrls: ['./conclusion-form.component.scss'],
    providers: [
        ConclusionFormDataService,
    ]
})
export class ConclusionFormComponent extends FrontendFormComponent {

    public afterSaveMessage = NotyMessagesEnum.conclusionUpdatedMessage;

    public conclusionId: number;

    public conclusionReasonsSelectValues = Conclusion.ConclusionReasonSelectValues;

    public methodTitle: string;

    public deviceUrl: string;

    public listUrl = RoutesStorage.Conclusion.list;

    public isInspectionSelected$ = this.dataService.isInspectionSelected$;

    private elementId: number;

    constructor(
        public formService: TechnicalDeviceElementApiService,
        private route: ActivatedRoute,
        private router: Router,
        public dataService: ConclusionFormDataService,
        private events: EventsService,
        injector: Injector
    ) {
        super(injector);
    }

    get form(): FormGroup {
        return this.dataService.form;
    }

    get saveUrl() {
        return this.formService.getConclusionPath(this.elementId);
    }

    init() {
        this.conclusionId = Number(this.route.snapshot.params.id);

        this.dataService.init();
        this.elementId = this.dataService.technicalDeviceElement.id;

        this.deviceUrl = RoutesStorage.TechnicalDevice.view(this.dataService.technicalDeviceId);

        this.methodTitle = Utils.deepGet(this.route.snapshot.data.technicalCard, 'method.short_title');
        /**
         * Пока нет возможности отключить скролл на уровне роутинга, так как на эту страницу попадаем из двух мест:
         * 1. Из списка заключений - скролл нужен
         * 2. Из модалки параметров контроля внутри этой формы - скролл не нужен.
         * ПОэтому на уровне роутинга скролл выключен, а при инициализации формы скроллим вручную
         */
        ScrollToService.toTop();
    }

    beforeSave() {
        this.events.showPreloader('Подождите, система формирует заключение');
    }

    preventSave() {
        if (this.dataService.inspectionsUpdating$.getValue()) {
            this.events.showNoty({
                type: 'info',
                content: 'Дождитесь обновления информации по контролю',
                timeout: 5000,
            });
            return true;
        }
        return false;
    }

    afterError() {
        this.events.hidePreloader();
    }

    afterSave(id: number) {
        super.afterSave();
        this.isPending = true;
        this.events.hidePreloader();
        this.redirectToDevice();
    }

    private redirectToDevice() {
        this.router.navigate([this.deviceUrl]);
    }
}
